export default "__VITE_ASSET__3e14c4f3__"